<template>
  <div v-if="showNote" class="printer-inline-note">
    ...<div class="inner"><p class="note">{{note}}</p></div>
  </div>
</template>

<script>
  export default {
    name: 'printer-inline-note',
    props: {
      note: {
        type: String
      },
      iconStyle: {
        type: Object
      }
    },
    computed: {
      showNote() {
        return this.note !== null && this.note.trim() !== '';
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../scss/theme";
  .printer-inline-note {
    margin-left: 18px;
    margin-top: 2px;
    border-radius: $s-x-small-border-radius;
    padding: 4px 16px;
    position: relative;
    display: inline-block;
    z-index: 10;
    background: #f1f1f1;

    .inner {
      font-size: 0;
      cursor: help;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      background: #f1f1f1; // #FFFE8E was better!
      border-radius: $s-x-small-border-radius;
      transition: .1s;
      padding: 12px 16px;
      z-index: 10;

      p {
        position: relative;
        width: 320px;
      }

    }

    &:hover {
      .inner {
        opacity: 1;
        font-size: 14px;
      }
    }
  }
</style>